import { init } from '../../../init-streaming';
import { UsageBasedPricingPage } from '../../../pages/software/rovo/pricing/usage-based-pricing/usage-based-pricing-page.tsx';

init(UsageBasedPricingPage);
